module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDI2N2YiIGQ9Ik0wIDBoMTcwLjY3djUxMkgweiIvPgogICAgPHBhdGggZmlsbD0iI2YzMTgzMCIgZD0iTTM0MS4zMyAwSDUxMnY1MTJIMzQxLjMzeiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/wf.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/wf.svg
// module chunks = 0